export default {
	'body-case': require('./body-case'),
	'body-empty': require('./body-empty'),
	'body-leading-blank': require('./body-leading-blank'),
	'body-max-length': require('./body-max-length'),
	'body-max-line-length': require('./body-max-line-length'),
	'body-min-length': require('./body-min-length'),
	'footer-empty': require('./footer-empty'),
	'footer-leading-blank': require('./footer-leading-blank'),
	'footer-max-length': require('./footer-max-length'),
	'footer-max-line-length': require('./footer-max-line-length'),
	'footer-min-length': require('./footer-min-length'),
	'header-case': require('./header-case'),
	'header-full-stop': require('./header-full-stop'),
	'header-max-length': require('./header-max-length'),
	'header-min-length': require('./header-min-length'),
	'references-empty': require('./references-empty'),
	'scope-case': require('./scope-case'),
	'scope-empty': require('./scope-empty'),
	'scope-enum': require('./scope-enum'),
	'scope-max-length': require('./scope-max-length'),
	'scope-min-length': require('./scope-min-length'),
	'signed-off-by': require('./signed-off-by'),
	'subject-case': require('./subject-case'),
	'subject-empty': require('./subject-empty'),
	'subject-full-stop': require('./subject-full-stop'),
	'subject-max-length': require('./subject-max-length'),
	'subject-min-length': require('./subject-min-length'),
	'type-case': require('./type-case'),
	'type-empty': require('./type-empty'),
	'type-enum': require('./type-enum'),
	'type-max-length': require('./type-max-length'),
	'type-min-length': require('./type-min-length')
};
